import { USER_INFO } from "../settings/config";

export const getUserInfoFromLocalStorage = () => {
    const userInfo = localStorage.getItem(USER_INFO);
    return userInfo ? JSON.parse(userInfo) : null;
};